import {
  Button,
  ButtonGroup,
  Divider,
  Drawer,
  List,
  ListItem,
  ListSubheader,
  Toolbar,
} from '@mui/material'
import { useContext } from 'react'
import { LayoutContext } from '../../contexts/LayoutContext'
import { ProfileContext, ThemeVariation } from '../../contexts/ProfileContext'
import WbSunnyIcon from '@mui/icons-material/WbSunny'
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness'
import DarkModeIcon from '@mui/icons-material/DarkMode'

export function Settings() {
  const { settings } = useContext(LayoutContext)
  const { theme, changeTheme } = useContext(ProfileContext)

  return (
    <Drawer
      anchor={'right'}
      open={settings.open}
      onClose={settings.toggle}
      PaperProps={{
        sx: {
          backgroundColor: 'background.paper',
          backgroundImage: 'none',
        },
      }}
    >
      <Toolbar />
      <Divider />
      <List
        subheader={<ListSubheader>Þema</ListSubheader>}
        sx={{ bgcolor: 'background.paper' }}
      >
        <ListItem>
          <ButtonGroup aria-label='theme button group'>
            <Button
              startIcon={<WbSunnyIcon />}
              variant={
                theme === ThemeVariation.Light ? 'contained' : 'outlined'
              }
              onClick={() => changeTheme(ThemeVariation.Light)}
            >
              Ljóst
            </Button>
            <Button
              startIcon={<SettingsBrightnessIcon />}
              variant={
                theme === ThemeVariation.System ? 'contained' : 'outlined'
              }
              onClick={() => changeTheme(ThemeVariation.System)}
            >
              Kerfi
            </Button>
            <Button
              startIcon={<DarkModeIcon />}
              variant={theme === ThemeVariation.Dark ? 'contained' : 'outlined'}
              onClick={() => changeTheme(ThemeVariation.Dark)}
            >
              Dökkt
            </Button>
          </ButtonGroup>
        </ListItem>
      </List>
    </Drawer>
  )
}
